export enum ProjectOAuth2DiscordPrompt {
    None = 'none',
    Consent = 'consent',
}
